<template>
  <div class="error-panel">
    <aha-icon
      name="warning-circle"
      class="text-base-55 mb-2"
      width="16"
      height="16"
      viewBox="0 0 14 14"
    ></aha-icon>
    <p>
      {{ $i18nPresenter.t('We ran into a hiccup and couldn’t check the latest version of your content.') }}
      <aha-antd-button
        variant="text-link"
        :underline="true"
        class="recheck-button"
        @click="onTryAgainButtonClicked"
        name="spellchecker-try-again-button"
        v-aha-emit-action
      >
        {{ $i18nPresenter.t('Recheck') }}
      </aha-antd-button>
    </p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      presentationId: (state) => state.presentation?.id,
    }),
  },

  methods: {
    ...mapActions('spellchecker', ['fetchMisspellListAction']),

    async onTryAgainButtonClicked() {
      await this.fetchMisspellListAction(this.presentationId)
    },
  },
}
</script>

<style lang="scss" scoped>
.error-panel {
  @apply w-full items-center justify-center px-4 py-12 text-center;
  .recheck-button {
    @apply inline-block py-0 px-0.5;
    height:  max-content;
  }
}
</style>
